import { ShoppingCartIcon } from "@phosphor-icons/react/dist/ssr/ShoppingCart";
import { motion } from "motion/react";

import { MOTION } from "@up/ui";

export const CartEmpty = function CartEmpty() {
  return (
    <motion.div className="overflow-hidden" {...MOTION["fade-in"].props}>
      <motion.div
        animate={{ x: 0 }}
        initial={{ x: "-25%" }}
        transition={{ type: "spring", bounce: 0.4, duration: 0.6 }}
      >
        <ShoppingCartIcon className="mx-auto" size="128" weight="thin" />
      </motion.div>
      <p
        data-testid="cart-empty-text"
        style={{
          paddingTop: "1rem",
          fontSize: "1.5rem",
          textAlign: "center",
        }}
      >
        Your cart is empty
      </p>
    </motion.div>
  );
};
